import { useMediaQuery } from "./useMediaQuery";

/**
 * Hook para detectar dispositivos móviles (<768px)
 * @returns boolean indicando si es móvil
 *
 * @example
 * const isMobile = useIsMobile();
 *
 * return (
 *   <div>
 *     {isMobile ? <MobileView /> : <DesktopView />}
 *   </div>
 * );
 */
export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 767px)");
}
